import { Fish, FishDefinition } from "../fish";
import { SchoolAttributes } from "../robofish";
import { clownfish } from "./clownfish";
import { goldfish1 } from "./goldfish1";
import { grayfish1 } from "./grayfish1";
import { pufferfish1 } from "./pufferfish1";
import { pufferfish2 } from "./pufferfish2";
import { pufferfish3 } from "./pufferfish3";
import { tinyfish1 } from "./tinyfish1";
import { willemfish1 } from "./willemfish1";

export const makeFishList = async (): Promise<
  (FishDefinition & { school: SchoolAttributes })[]
> => {
  return [
    {
      sprite: goldfish1,
      attributes: {
        topSpeed: 1.25,
        turnSpeed: 1,
        acceleration: 1,
        rarity: 0,
      },
      school: {
        spread: 300,
        minSize: 1,
        maxSize: 5,
        tick: (f: Fish[]) => {
          if (Math.random() < 0.2) {
            const dx = (1 - 2 * Math.random()) * 2;
            const dy = 1 - 2 * Math.random();
            for (const fsh of f) {
              setTimeout(() => {
                fsh.dx = dx;
                fsh.dy = dy;
              }, 1000 * Math.random());
            }
          }
        },
      },
    },
    {
      sprite: grayfish1,
      attributes: {
        turnSpeed: 0.5,
        topSpeed: 1,
        acceleration: 0.5,
        rarity: 0.25,
      },
      school: {
        spread: 600,
        minSize: 1,
        maxSize: 10,
        tick: (f: Fish[]) => {
          if (Math.random() < 0.2) {
            const dx = (1 - 2 * Math.random()) * 10;
            const dy = 1 - 2 * Math.random();
            for (const fsh of f) {
              setTimeout(() => {
                fsh.dx = dx;
                fsh.dy = dy;
              }, 1000 * Math.random());
            }
          }
        },
      },
    },
    {
      sprite: clownfish,
      attributes: {
        topSpeed: 0.75,
        turnSpeed: 1.25,
        acceleration: 1,
        rarity: 0.5,
      },
      school: {
        spread: 300,
        minSize: 1,
        maxSize: 1,
        tick: (f: Fish[]) => {
          if (Math.random() < 0.4) {
            const dx = 1 - 2 * Math.random();
            const dy = 1 - 2 * Math.random();
            for (const fsh of f) {
              setTimeout(() => {
                fsh.dx = dx;
                fsh.dy = dy;
              }, 1000 * Math.random());
            }
          }
        },
      },
    },
    {
      sprite: tinyfish1,
      attributes: {
        topSpeed: 1.5,
        turnSpeed: 1.25,
        acceleration: 1.25,
        rarity: 0.5,
      },
      school: {
        tick: (f: Fish[]) => {
          if (Math.random() < 0.4) {
            const dx = (1 - 2 * Math.random()) * 5;
            const dy = 1 - 2 * Math.random();
            for (const fsh of f) {
              setTimeout(() => {
                fsh.dx = dx;
                fsh.dy = dy;
              }, 1000 * Math.random());
            }
          }
        },
        spread: 300,
        minSize: 10,
        maxSize: 20,
      },
    },
    {
      sprite: willemfish1,
      attributes: {
        topSpeed: 1,
        turnSpeed: 1,
        acceleration: 1.5,
        rarity: 0,
      },
      school: {
        spread: 10,
        minSize: 1,
        maxSize: 1,
        tick: (f: Fish[]) => {
          if (Math.random() < 0.2) {
            const dx = (1 - 2 * Math.random()) * 4;
            const dy = 1 - 2 * Math.random();
            for (const fsh of f) {
              setTimeout(() => {
                fsh.dx = dx;
                fsh.dy = dy;
              }, 1000 * Math.random());
            }
          }
        },
      },
    },
    {
      sprite: pufferfish1,
      attributes: {
        topSpeed: 1,
        turnSpeed: 1,
        acceleration: 1,
        rarity: 0,
      },
      school: {
        spread: 10,
        minSize: 1,
        maxSize: 1,
        tick: (f: Fish[]) => {
          if (Math.random() < 0.2) {
            const dx = (1 - 2 * Math.random()) * 4;
            const dy = 1 - 2 * Math.random();
            for (const fsh of f) {
              const pufferfish = fsh as PufferFish;
              if (Math.random() < 0.1 && !pufferfish.puffing) {
                pufferfish.puffing = true;
                if (pufferfish.puffed) {
                  pufferfish.puffed = false;
                  const unpuffed = pufferfish1();
                  pufferfish3().then((p) => {
                    p.textures.reverse();
                    pufferfish.sprite.textures = p.textures;
                    pufferfish.sprite.loop = false;
                    pufferfish.sprite.onComplete = () => {
                      unpuffed.then((p2) => {
                        pufferfish.sprite.loop = true;
                        pufferfish.sprite.textures = p2.textures;
                        pufferfish.puffing = false;
                        pufferfish.sprite.onComplete = undefined;
                      });
                    };
                  });
                } else {
                  pufferfish.puffed = true;
                  const puffed = pufferfish2();
                  pufferfish3().then((p) => {
                    pufferfish.sprite.textures = p.textures;
                    pufferfish.sprite.loop = false;
                    pufferfish.sprite.onComplete = () => {
                      puffed.then((p2) => {
                        pufferfish.sprite.loop = true;
                        pufferfish.sprite.textures = p2.textures;
                        pufferfish.puffing = false;
                        pufferfish.sprite.onComplete = undefined;
                      });
                    };
                  });
                }
              }
              setTimeout(() => {
                pufferfish.dx = dx;
                pufferfish.dy = dy;
              }, 1000 * Math.random());
            }
          }
        },
      },
    },
  ];
};

type PufferFish = Fish & { puffed: boolean; puffing: boolean };
